import BaseRepository from "./BaseRepository";
import st from "lib/utils/index";
import { AdminUserFullDecorator } from "lib/decorators/index";

export default new (class AccountRepository extends BaseRepository {
  show() {
    return this.api
      .get(`/account`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((user) => new AdminUserFullDecorator(user));
  }

  login({ email, password }) {
    return this.api.post(`/account/login`, { admin_user: { email, password } }).map((response) => ({
      user: new AdminUserFullDecorator(st.api.dejsonapinize(response.data.data, response.data.included)),
      meta: response.data.meta,
    }));
  }

  // Headers are captured up front: LOGOUT clears the ApiService credentials right after
  logout() {
    const headers = {
      "X-Admin-Email": this.api.currentAdminUserEmail,
      "X-Admin-Token": this.api.currentAdminUserToken,
    };
    return this.api.post(`/account/logout`, null, { headers });
  }

  update(data) {
    return this.api
      .put(`/account`, {
        admin_user: data,
      })
      .map((response) => ({
        user: new AdminUserFullDecorator(st.api.dejsonapinize(response.data.data, response.data.included)),
        meta: response.data.meta,
      }));
  }

  sendResetPasswordInstructions(email) {
    return this.api.post(`/account/send_reset_password_instructions`, {
      admin_user: { email },
    });
  }

  resetPassword({ reset_password_token, password, password_confirmation = password }) {
    return this.api
      .post(`/account/reset_password`, {
        admin_user: { reset_password_token, password, password_confirmation },
      })
      .map((response) => ({
        user: new AdminUserFullDecorator(st.api.dejsonapinize(response.data.data, response.data.included)),
        meta: response.data.meta,
      }));
  }

  sendConfirmationInstructions(email) {
    return this.api.post(`/account/send_confirmation_instructions`, {
      admin_user: { email },
    });
  }

  confirmEmail(confirmation_token) {
    return this.api.post(`/account/confirm_email`, { confirmation_token });
  }

  sendUnlockInstructions(email) {
    return this.api.post(`/account/send_unlock_instructions`, {
      admin_user: { email },
    });
  }

  unlockAccess(unlock_token) {
    return this.api.post(`/account/unlock_access`, { unlock_token });
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/AccountRepository.js